export class GroupEventOrder {
  nameOfOrganization: string;
  surnameOfContact: string;
  nameOfContact: string;
  street: string;
  zip: string;
  phone: string;
  email: string;
  date: string;
  otherInfo: string;
  guestCount: number;

  toJSON(): any {
    return {
      nameOfOrganization: this.nameOfOrganization,
      surnameOfContact: this.surnameOfContact,
      nameOfContact: this.nameOfContact,
      street: this.street,
      zip: this.zip,
      phone: this.phone,
      email: this.email,
      date: this.date,
      otherInfo: this.otherInfo,
      guestCount: this.guestCount,
    };
  }
}
